import CategoryTile from 'LuxKit/CategoryTile'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useMerchandiseCategory from 'hooks/Merchandise/useMerchandiseCategory'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { getMerchandiseCategoryPageUrl } from '../merchandiseUtils'

const Tile = styled(CategoryTile)`
  && {
    min-height: auto;
    height: ${rem(160)};
  }

  ${mediaQueryUp.tablet} {
    && {
      min-height: auto;
      height: ${rem(270)};
    }
  }
`

const CardSkeleton = styled(LoadingBox)`
  width: 100%;
  height: ${rem(160)};

  ${mediaQueryUp.tablet} {
    height: ${rem(270)};
  }
`

interface Props {
  id: string
}

function MerchandiseCategoryGridCard(props: Props) {
  const { id } = props
  const [category] = useMerchandiseCategory({ id })

  if (!category) {
    return <CardSkeleton />
  }

  return <Tile
    to={getMerchandiseCategoryPageUrl(category)}
    image={category.image!}
    heading={category.name}
    align="bottom"
  />
}

export default MerchandiseCategoryGridCard
